import * as React from "react"

const GoldBannerLarge: React.FC = () => {
  return (
    <span className="inline-flex  flex-row items-center bg-[#AB8D51] w-[55px] h-[22px] rounded-md py-[2px] px-[4px] gap-x-[4px]">
      <img
        src="/icons/star.svg"
        alt="lotus-gold"
        className="w-[16px] h-[16px]"
      />
      <div className="font-extrabold text-white text-[12px]">Gold</div>
    </span>
  )
}

export default GoldBannerLarge
